import React, { Component } from 'react';
import {finishSync} from '../../api/strava/sync.js';

import './StravaAuth.css';
import logo from 'static/img/logo.svg';

import {AuthManager} from "../../components/Authentication/AuthManager"

class StravaAuth extends Component {

  getParameterByName(name) {
    var urlParams = new URLSearchParams(window.location.search);
    return urlParams.has(name) ? urlParams.get(name) : '';
}

  constructor(props) {
      super(props);
      this.state = {
        strava_sync_success: false,
        strava_sync_failed: false,
        strava_sync_done: false
      };

      this._authManager = new AuthManager();
    }

  finishStravaSync(stravaAuthCode){
    finishSync(stravaAuthCode)
      .then((r)=>{

        if(r.status === 200){
          this.setState({strava_sync_success: true, strava_sync_done: true});
        }
        else {
          console.log(r);
          this.setState({strava_sync_failed: true, strava_sync_done: true});
        }
      })
      .catch((e)=>{
        console.log(e);
        this.setState({strava_sync_failed: true, strava_sync_done: true});
      });
  }

  componentDidMount(){
    let stravaAuthCode = this.getParameterByName("code");
    this.finishStravaSync(stravaAuthCode);
  }

  redirectToDashboard(){
    window.location = "/dashboard";
  }

  renderSyncInProgress() {return (<p>Strava synchronization in progress...</p>);}
  renderSyncFailed() {return (<p>Strava synchronization failed.</p>);}
  renderSyncSucceeded() {return (<p>Your account is connected.</p>);}

  renderSuccessCheck(){
    return  <div className="StravaAuth__confirmation" onClick={this.redirectToDashboard}>
              <div className="check_mark">
                <div className="sa-icon sa-success animate">
                  <span className="sa-line sa-tip animateSuccessTip"></span>
                  <span className="sa-line sa-long animateSuccessLong"></span>
                  <div className="sa-placeholder"></div>
                  <div className="sa-fix"></div>
                </div>
              </div>
            </div>;
  }
  render() {
    return (
      <div className="StravaAuth">
        <img src={logo} alt="Logo" className="logo"/>
        {this.state.strava_sync_done || this.renderSyncInProgress()}
        {this.state.strava_sync_failed && this.renderSyncFailed()}
        {this.state.strava_sync_success && this.renderSyncSucceeded()}
        {this.state.strava_sync_success && this.renderSuccessCheck()}
      </div>
    );
  }
}

export default StravaAuth;



// WEBPACK FOOTER //
// ./src/screens/stravaAuth/StravaConfirmation.js